import { createContext } from "react";

const BannerContext = createContext({
  variant: "info",
  inverse: false,
  onDismiss: null,
});

export default BannerContext;
